/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsResendConfirmationCode204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsResendConfirmationCode505Schema = z.any();

export const optionsResendConfirmationCodeMutationResponseSchema = z.lazy(() => optionsResendConfirmationCode204Schema);
